import { LineChart, Line } from 'recharts';
import type { PeriodBucket } from '../types/weeklyMetrics';

interface MetricSparklineProps {
  weeks: PeriodBucket[];
  effectiveTrend: 'positive' | 'negative' | 'neutral' | null;
}

const trendColors: Record<string, string> = {
  positive: '#16a34a', // green-600
  negative: '#dc2626', // red-600
  neutral: '#6b7280', // gray-500
};

export default function MetricSparkline({ weeks, effectiveTrend }: MetricSparklineProps) {
  if (weeks.length < 2) return null;

  const color = trendColors[effectiveTrend || 'neutral'];

  return (
    <LineChart width={120} height={32} data={weeks}>
      <Line
        type="monotone"
        dataKey="value"
        stroke={color}
        strokeWidth={1.5}
        dot={false}
        isAnimationActive={false}
      />
    </LineChart>
  );
}
